const modalTypes = {
  change: {
    title: 'sales_manager.sales_group.modal.change_plus_offers',
    description: 'sales_manager.sales_group.modal.changed_plus_offers',
    conditions: [
      {
        condition: 'first',
        description:
          'sales_manager.sales_group.modal.change_plus_offers_condition_1'
      },
      {
        condition: 'second',
        description:
          'sales_manager.sales_group.modal.change_plus_offers_condition_2'
      }
    ]
  },
  activate: {
    title: 'sales_manager.sales_group.modal.activate_plus_offers',
    description: 'sales_manager.sales_group.modal.plus_offers_will_activated',
    conditions: [
      {
        condition: 'first',
        description:
          'sales_manager.sales_group.modal.activate_plus_offers_condition_1'
      },
      {
        condition: 'second',
        description:
          'sales_manager.sales_group.modal.activate_plus_offers_condition_2'
      }
    ]
  },
  disable: {
    title: 'sales_manager.sales_group.modal.disable_plus_offers',
    description: 'sales_manager.sales_group.modal.plus_offers_will_disabled',
    conditions: [
      {
        condition: 'first',
        description:
          'sales_manager.sales_group.modal.disable_plus_offers_condition_1'
      },
      {
        condition: 'second',
        description:
          'sales_manager.sales_group.modal.disable_plus_offers_condition_2'
      },
      {
        condition: 'third',
        description:
          'sales_manager.sales_group.modal.disable_plus_offers_condition_3'
      }
    ]
  }
};

const TABS = {
  CAMPAIGNS: 0,
  SALES_INFO: 1,
  PLUS_ACCESS: 2,
  SUBSCRIPTION: 3
};

const MAX_DESCRIPTION_LENGTH = 500;

const SALES_ALERT = {
  OFFER_NOT_FOUND_HOME_PAGE: 'OFFER_NOT_FOUND_HOME_PAGE',
  OFFER_NOT_FOUND_SALES_INFORMATION_PAGE:
    'OFFER_NOT_FOUND_SALES_INFORMATION_PAGE'
};

const USER_EVENT = {
  OFFER_NOT_FOUND_HOME_DISMISSED: 'OFFER_NOT_FOUND_HOME_DISMISSED',
  OFFER_NOT_FOUND_SALES_PAGE_DISMISSED: 'OFFER_NOT_FOUND_SALES_PAGE_DISMISSED'
};

export { modalTypes, TABS, MAX_DESCRIPTION_LENGTH, SALES_ALERT, USER_EVENT };
